// import React, { useState, useCallback, useEffect, useMemo } from 'react';
import NumberFormat from 'react-number-format';

const NumberFormatML = React.forwardRef(function NumberFormatCustom(
  props,
  ref,
) {
  const { onChange, allowNegative, decimalScale, ...other } = props;

  // const allowedRules = {
  //   isPositiveNumber: (val) => {
  //     console.log('💢felix => val', val);
  //     return val >= 0;
  //   },
  // };

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      thousandsGroupStyle="thousand"
      // defaultValue={''}
      thousandSeparator={true}
      allowNegative={allowNegative}
      isNumericString
      prefix=""
      decimalScale={decimalScale}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      // isAllowed={({ floatValue }) => {
      //   console.log('💢felix => isPositiveNumber', isPositiveNumber);
      //   console.log('💢felix => floatValue', floatValue);
      //   return isPositiveNumber && rule.isPositiveNumber(floatValue);
      // }}
    />
  );
});

export default NumberFormatML;
